import React from "react";
import { useParticipantDetails } from "../context/participantDetails";

export default function useScreenName(message?: string) {
  const { setScreenName } = useParticipantDetails();
  React.useEffect(() => {
    message && setScreenName(message);
    return () => setScreenName("");
  }, [message, setScreenName]);

  return { setScreenName };
}
